import React, { useEffect, useState } from 'react';
import { useNavigate , useParams} from 'react-router-dom';
import CamperVideoService from '../../api/services/CamperVideoService';
import MainPagetitle from '../../layouts/MainPagetitle';


const EditCamperVideo = () => {
    const params = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [camper, setCamper] = useState([]);
  const [camperType,setCamperType] = useState([]);
  const [videoType, setVideoType] = useState([]);
  const [tutorial, setTutorial] = useState([]);
  
  useEffect(() => {
    var id = params.id;
    getTutorialByID(id);
    getCamper();
    getCamperType();
    getVideoType();

  }, []);
  // ----------- get Camper  ------------ //
  const getCamper = async () => {
    try {
      let camper = await CamperVideoService.camper_index().json();
      setCamper(camper.data);
      
    } catch (error) {
      console.log(error);
    }
  };

  // ----------- get Camper Type  ------------ //
  const getCamperType = async () => {
    try {
      let fuel = await CamperVideoService.camperType().json();
      setCamperType(fuel.data);
    } catch (error) {
        if (error.name === 'HTTPError') {
            const errorJson = await error.response.json();
            setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
          }
    }
  };
   // ----------- get Video Type   ------------ //
  const getVideoType = async () => {
    try {
      let type = await CamperVideoService.videoType().json();
    setVideoType(type.data);
    } catch (error) {
        if (error.name === 'HTTPError') {
            const errorJson = await error.response.json();
            setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
          }
    }
  };

  const getTutorialByID = async (id) => {
    try {
      let tutorial = await CamperVideoService.show(id).json();
      setTutorial(tutorial.data);
      // console.log(tutorial.data)
    } catch (error) {
        if (error.name === 'HTTPError') {
            const errorJson = await error.response.json();
            setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
          }
    }
  };

  const onSubmitForm = async (event) => {
    event.preventDefault();
    setError("")
    try {
      var userData = {
          "camper_id": event.target.camper_id.value,
          "camper_type_id": event.target.camper_type_id.value,
          "video_type_id": event.target.video_type_id.value,
          "video": event.target.video.value,
          "description": event.target.description.value,
          
      }
      console.log(userData)
      let responseData = await CamperVideoService.update(params.id,userData).json()
      // console.log(responseData)
      if (responseData.status === true) {
        navigate("/admin/explanatory-videos");
      }
    } catch (error) {
        console.log(error)
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
      }
    
  };

  return (
    <>
      <MainPagetitle mainTitle="Edit Camper Video" pageTitle={'Edit Camper Video'} parentTitle={'Home'} />
      <div className="container-fluid">
            <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                            <h4 className="card-title">Camper Explanatory Video</h4>
                            </div>
                            <div className="card-body">
                                <form className="form-valide" onSubmit={onSubmitForm}>
                                <div className="row">
                                    <div className="col-xl-12 mb-3">
                                        <label htmlFor="val-username" className="form-label" >Camper<span className="text-danger">*</span></label>
                                        <select className="form-control" id="val-skill" name="camper_id">
                                          {camper.map((option) => {
                                                return (
                                                    <option key={option.id} value={option.id} selected={tutorial.camper_id == option.id}>
                                                    {option.title}
                                                    </option>
                                                );
                                            })}   
                                        </select>

                                    </div>
                                    <div className="col-xl-12 mb-3">
                                        <label htmlFor="val-username" className="form-label" >Camper Type<span className="text-danger">*</span></label>
                                        <select className="form-control" id="val-username" name="camper_type_id">
                                         {camperType.map((option) => {
                                                return (
                                                    <option key={option.id} value={option.id} selected={tutorial.camper_type_id == option.id}>
                                                    {option.type}
                                                    </option>
                                                );
                                            })}
                                        </select>

                                    </div>
                                    <div className="col-xl-12 mb-3">
                                        <label htmlFor="video_type_id" className="form-label" >Explanatory Type<span className="text-danger">*</span></label>
                                        <select className="form-control" id="video_type_id" name="video_type_id">
                                         {videoType.map((option) => {
                                                return (
                                                    <option key={option.id} value={option.id} selected={tutorial.video_type_id == option.id}>
                                                    {option.explanatory_type}
                                                    </option>
                                                );
                                            })}
                                        </select>

                                    </div>
                                    <div className="col-xl-12 mb-3">
                                        <label htmlFor="val-username" className="form-label" >Explanatory Video<span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" name='video' id="val-username" placeholder=""  defaultValue={
                                                    tutorial.video
                                                    ?  tutorial.video
                                                    : ''
                                                }/>
                                    </div>
                                    <div className="col-xl-12 mb-3">
                                        <label className="form-label" htmlFor="val-suggestions">Description <span className="text-danger">*</span></label>
                                        <textarea rows="3"  id="val-suggestions" className="form-control" name='description' defaultValue={
                                                    tutorial.description
                                                    ?  tutorial.description
                                                    : ''
                                                } ></textarea>
                                    </div>
                                </div>
                               <h5 style={{color:'red'}}>{error}</h5>
                                <div>
                                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
           
            </div>
        
      </div>

    </>
  );
};
export default EditCamperVideo;